import { Injectable } from '@angular/core';
import * as constants from '../constants-types/constants';
import { SearchState } from '../core-data-model/SearchState.model';
import { UserProfileSettingsService } from '../system-services/UserProfileSettings/UserProfileSettings.service';

@Injectable({
    providedIn: 'root'
})
export class SearchStateFactory {
    constructor(private userProfileSettings: UserProfileSettingsService) {}
    newSearchState(): SearchState {
        return new SearchState().setPageSize(
            this.userProfileSettings.preferredPageSize ||
                constants.tableDefaultResultsPerPage
        );
    }
}
